'use client';

import type { LiveSortType } from '@module/helpers/live/getResolvedLiveSort';
import useLiveSortState from '@module/helpers/live/useLiveSortState';
import { cn } from '@module/lib/utils';
import { LiveRefresh } from '@module/svg/icons';
import BaseButton from '@pc/components/atoms/button/BaseButton';
import ButtonSeperator from '@pc/components/atoms/seperator/ButtonSeperator';
import MainTitle from '@pc/components/atoms/typograph/MainTitle';
import { useQueryClient } from '@tanstack/react-query';
import dynamic from 'next/dynamic';

/* RT 대응 - 전환 후 삭제 예정 */
const liveSortOptions: Array<{ key: LiveSortType; label: string; gtm: string }> = [
  // { key: 'onlyRealTimeYN', label: '시차 없는 LIVE+', gtm: 'rtbj' }, // RT 대응 - 임시 주석처리
  { key: 'newbj', label: 'NEW BJ', gtm: 'newbj' },
  { key: 'hot', label: '인기순', gtm: 'hot' },
  { key: 'new', label: '최신순', gtm: 'new' },
  { key: 'viewcount', label: '시청순', gtm: 'viewcount' },
];

function SearchLinkOptionInner() {
  const queryClient = useQueryClient();
  const { sortType, setSelectedSortType } = useLiveSortState();

  return (
    <div
      id='live-search-container'
      className='sticky top-0 z-[12] flex justify-between pt-[20px]'
      data-gtm-live-sort-selected-method={sortType}
    >
      <div className='flex [&>*]:mr-2'>
        <MainTitle>LIVE</MainTitle>
        <BaseButton
          throttleDelay={1500}
          size='none'
          variant='ghost'
          className='flex h-6 w-6 items-center justify-center rounded-md bg-none'
          onClick={() => {
            queryClient.resetQueries({ queryKey: ['live', 'fetchLiveInfinite'] });
          }}
        >
          <LiveRefresh className='h-4 w-4' />
        </BaseButton>
      </div>
      <div className='flex items-center gap-2'>
        {liveSortOptions.map(({ key, label, gtm }, index) => (
          <div key={key} className='flex items-center gap-2'>
            <button
              type='button'
              onClick={() => setSelectedSortType(key)}
              className={cn('text-colorFg01', {
                'font-[700]': sortType === key,
              })}
              data-gtm-live-sort-method={gtm}
            >
              {label}
            </button>
            {index < liveSortOptions.length - 1 && <ButtonSeperator />}
          </div>
        ))}
      </div>
    </div>
  );
}

function SearchLinkOptionSkeleton() {
  return (
    <div id='live-search-container' className='sticky top-0 z-[12] flex justify-between pt-[20px]' aria-hidden='true'>
      <div className='flex [&>*]:mr-2'>
        <div className='mb-6 h-[28px] w-[58px]' />
        <div className='h-6 w-6' />
      </div>
      <div className='flex items-center gap-2'>
        <div className='h-5 w-[52px]' />
        <div className='h-5 w-[1px]' />
        <div className='h-5 w-[52px]' />
        <div className='h-5 w-[1px]' />
        <div className='h-5 w-[52px]' />
        <div className='h-5 w-[1px]' />
        <div className='h-5 w-[52px]' />
      </div>
    </div>
  );
}

const SearchLinkOption = dynamic(() => Promise.resolve(SearchLinkOptionInner), {
  ssr: false,
  loading: () => <SearchLinkOptionSkeleton />,
});

export default SearchLinkOption;
